import React, { useState, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import timelinePlugin from '@fullcalendar/timeline';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';

const Calendario = (props) => {
    const { eventos, accion } = props;
    const [date, setDate] = useState(moment().toDate());
    const calendarRef = useRef(null);

    const accionClick = (info) => {
        const eventoInfo = {
            fecha: info.event.start,
            titulo: info.event.title
        };

        if (info.event.extendedProps) {
            eventoInfo.desc = info.event.extendedProps.desc;
            eventoInfo.tipo = info.event.extendedProps.tipo;
            eventoInfo.oficial = info.event.extendedProps.oficial;
        }

        accion(eventoInfo);
    };

    const eventosFormateados = eventos.map((evento) => {
        const eventoCalendario = {
            id: evento.id,
            title: evento.title,
            start: evento.date,
            allDay: true,
            extendedProps: {
                desc: evento.desc,
                tipo: evento.tipo,
                oficial: evento.oficial
            }
        };

        if (evento.tipo === 'festivo') {
            if (evento.oficial) {
                eventoCalendario.backgroundColor = '#f5140c';
                eventoCalendario.borderColor = '#f9f9f9';
                eventoCalendario.textColor = '#ffffff';
            } else {
                eventoCalendario.backgroundColor = '#ffe082';
                eventoCalendario.borderColor = '#ffb300';
                eventoCalendario.textColor = '#bf360c';
            }
        } else if (evento.tipo === 'curso') {
            eventoCalendario.backgroundColor = '#1b6aca';
            eventoCalendario.borderColor = '#1240c9';
            eventoCalendario.textColor = '#ffffff';
        }

        return eventoCalendario;
    });

    return (
        <FullCalendar
            allDayMaintainDuration
            locale={'es'}
            defaultDate={date}
            eventClick={accionClick}
            events={eventosFormateados}
            header={false}
            height={380}
            buttonText={{ today: 'Hoy' }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
            ref={calendarRef}
            rerenderDelay={10}
            weekends
        />
    );
};

export default Calendario;
